/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BinaryData { 
    readonly length: number;
    readonly isEmpty: boolean;
    readonly mediaType?: string | null;
}

